import * as React from 'react';
import SearchView from 'containers/search';
import { PwrDistroMediaFieldsets } from 'containers/search/SearchForm';

export function MediaSearch(props) {
  return (
    <SearchView
      label="Images & Video"
      primaryFieldsets={PwrDistroMediaFieldsets.primaryFieldsets}
      extraFieldsets={PwrDistroMediaFieldsets.extraFieldsets}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/search/PwrDistribution/MediaSearch.js